import React from "react";
import { Route } from "react-router-dom";
import { RecordDataIndicators } from "../../../components/RecordDataIndicators";
import { DataProviderCache } from "../../../data/DataProviders/DataProviderCache";
import { SiteProfileDataProvider } from "../../../data/DataProviders/SiteProfileDataProvider";
import { useCurrentAppRoute } from "../../../hooks/app-route-hooks";
import { isRecordFound, useSelectedOrganizationData } from "../../../hooks/data-hooks";
import { useLanguageLocale } from "../../../hooks/language-locale-hooks";
import { AppRoutes } from "../../../routes";
import { LocationProfile } from "./LocationProfile";


export const LocationProfileContainer = (): JSX.Element => {
    const selectedOrganization = useSelectedOrganizationData();
    const { t } = useLanguageLocale();
    const currentAppRoute = useCurrentAppRoute()

    return (
        <>
            <RecordDataIndicators
                recordData={selectedOrganization}
                errorMessage={t('DASHBOARD.ERROR_LOADING_ORGANIZATION')}
                notFoundIcon="Business"
                notFoundMessage={t('DASHBOARD.ORGANIZATION_NOT_FOUND')}
            />

            {isRecordFound(selectedOrganization) && 'locationId' in currentAppRoute &&
                <DataProviderCache for={'location-profile'}>
                    <SiteProfileDataProvider siteId={currentAppRoute.locationId}>
                        <Route path={[AppRoutes.LocationProfile, AppRoutes.EditLocation]} >
                            <LocationProfile />
                        </Route>
                    </SiteProfileDataProvider>
                </DataProviderCache>
            }
        </>
    )
}
